<template>
    <div v-if="role === UserRole.ADMIN || role === UserRole.CHIEF_MANAGER || role === UserRole.MANAGER">
        <div class="order-list full-list" :class="{mt_80: props.margin}">
            <div class="order-list__title-box">
                <h2 class="order-list__title">Список заказов: {{ OrderType.monument }}</h2>
            </div>
            <div class="order-list__search mt-20">
                <h4>Поиск</h4>
                <form @submit.prevent="searchOrders">
                    <div class="order-list__search__params">
                        <div class="order-list__search__params__container" data-cnt="1">
                            <div class="order-list__search__container">
                                <div class="order-list__search__container__form-row">
                                    <input type="text" placeholder="Номер заказа" name="search" data-searchBy="number">
                                </div>
                            </div>
                            <v-select :options="searchOptions" label="title" placeholder="Выберите опции поиска"  @option:selected="selectSearchHandler">
                                <template #no-options="{ search, searching, loading }">
                                    Ничего не найдено.
                                </template>
                            </v-select>
                        </div>
                        <div class="order-list__search__params__container">
                            <div class="order-list__search__container">
                                <div class="order-list__search__container__form-row">
                                    <input type="text" placeholder="Дата заключения договора" data-searchBy="createdAt">
                                    <span>Дата заключения договора</span>
                                </div>
                            </div>
                        </div>
                        <div class="order-list__search__params__container">
                            <div class="order-list__search__container">
                                <div class="order-list__search__container__form-row">
                                    <input type="text" placeholder="Производимые работы" data-searchBy="services.title">
                                    <span>Производимые работы</span>
                                </div>
                            </div>
                        </div>
                        <div class="order-list__search__params__container">
                            <div class="order-list__search__container">
                                <div class="order-list__search__container__form-row">
                                    <input type="text" placeholder="Кладбище" data-searchBy="information.cemetery">
                                    <span>Кладбище</span>
                                </div>
                            </div>
                        </div>
                        <div class="order-list__search__params__container">
                            <div class="order-list__search__container">
                                <div class="order-list__search__container__form-row">
                                    <input type="text" placeholder="Приемщик заказа" data-searchBy="userId">
                                    <span>Приемщик заказа</span>
                                </div>
                            </div>
                        </div>
                        <div class="order-list__search__params__container">
                            <div class="order-list__search__container">
                                <div class="order-list__search__container__form-row">
                                    <input type="text" placeholder="Менеджер" data-searchBy="information.manager">
                                    <span>Менеджер</span>
                                </div>
                            </div>
                        </div>
                        <div class="order-list__search__params__container">
                            <div class="order-list__search__container">
                                <div class="order-list__search__container__form-row">
                                    <input type="text" placeholder="Статус" data-searchBy="status">
                                    <span>Статус</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="order-list__search__container__submit-row">
                        <div class="order-list__search__container__submit-row__submit">
                            <input type="submit" value="Искать">
                        </div> 
                    </div>
                </form>
            </div>
            <!-- <div class="order-list__filter">
                <h4>Фильтр</h4>
                <form @submit.prevent="filterOrders">
                    <div class="order-list__filter__container">
                        <div class="order-list__filter__form-row">
                            <input type="number" placeholder="Год создания заказа" name="createdAt">
                        </div>
                        <div class="order-list__filter__submit-row">
                            <input type="submit" value="Применить" data-filterBy="createdAt">
                        </div>
                    </div>
                    <div class="order-list__filter__container">
                        <div class="order-list__filter__form-row">
                            <input type="number" placeholder="Год начала работ" name="dates.startAt">
                        </div>
                        <div class="order-list__filter__submit-row">
                            <input type="submit" value="Применить" data-filterBy="dates.startAt">
                        </div>
                    </div>
                </form>
            </div> -->
            <div class="order-list__sort-container">
                <div class="order-list__sort-box" v-if="ordersTable.sortable">
                    <h4>Сортировка</h4>
                    <div class="order-list__sort" v-if="ordersTable.sortable.sort === 'asc'">
                        <icon-component class="order-list__icon" name="sortUp" width="20" height="20"/>
                        <span class="order-list__sort-button">по возрастанию</span>
                    </div>
                    <div class="order-list__sort" v-else>
                        <icon-component class="order-list__icon" name="sortDown" width="20" height="20"/>
                        <span class="order-list__sort-button">по убыванию</span>
                    </div>
                </div>
                <div class="order-list__download">
                    <div class="order-list__download-box">
                        <icon-component class="order-list__icon" name="download" width="20" height="20"/>
                        <button class="order-list__download-box-button" @click.prevent="downloadOrders">Скачать</button>
                    </div>
                </div>  
            </div>

            <table-lite
                :is-slot-mode="true"
                :is-loading="ordersTable.isLoading"
                :columns="ordersTable.columns"
                :rows="ordersTable.rows"
                :rowClasses="tableRowClassHandler"
                :total="ordersTable.total"
                :sortable="sortable"
                :messages="ordersTable.messages"
                :pageOptions="ordersTable.pageOptions"
                @do-search="getOrders"
                @VnodeMounted="initTable"
            >
            <template v-slot:C1="ordersTable">
                    <v-select 
                        :appendToBody="true"
                        :searchable="false"
                        :autoscroll="false"
                        :modelValue="ordersTable.value.C1.status"
                        :options="statuses" 
                        @option:selected="(status: OrderStatus) => { setStatus(ordersTable.value.C1._id, status) }"
                        v-if="ordersTable.value.C1 !== '' && ( (role === UserRole.MANAGER && ordersTable.value.C1.userId === userId) || (role === UserRole.ADMIN || role === UserRole.CHIEF_MANAGER) )"
                    />
                    <span v-else>{{ ordersTable.value.C1.status }}</span>
                </template>
                <template v-slot:B1="ordersTable">
                    <div class="order-list__action-box" v-if="ordersTable.value.B1 !== ''">
                        <VDropdown>
                            <button class="order-list__action">
                                <icon-component class="order-list__icon" name="action" width="32" height="32"/>
                            </button>
                            <template #popper>
                                <div class="order-list__option-box">
                                    <router-link :to="{ name: 'order', params: { orderId: ordersTable.value.B1._id } }" target="_blank" class="order-list__option">Подробнее</router-link>
                                    <button class="order-list__option" @click="openPopup = ordersTable.value.B1._id">Платежи</button>
                                    <button class="order-list__option" v-if="role !== UserRole.MANAGER" @click="isDelete = ordersTable.value.B1._id">Перевести в архив</button>
                                </div>
                            </template>
                        </VDropdown>
                    </div>
                    <popup-component :mt="true" :isOpen="openPopup === ordersTable.value.B1._id" @close="openPopup = '', activePayment = false">
                        <template #title>Платежи</template>
                        <template #additional_title_info>
                            <span class="payments__title payments__title_gold">Номер заказа: {{ordersTable.value.B1.region.slug + ordersTable.value.B1.index}}</span>
                            <span class="payments__title payments__title_gold">ФИО покойного: {{ordersTable.value.B1?.information.deceased}}</span>
                        </template>
                        <template #content>
                            <div class="payments__information">
                                <div class="payments__information-item">
                                    <span class="payments__title">Цена</span>
                                    <span class="payments__text payments__text_np">{{ordersTable.value.B1.price.total}} руб</span>
                                </div>
                                <div class="payments__information-item">
                                    <span class="payments__title">Скидка</span>
                                    <span class="payments__text payments__text_np">{{ordersTable.value.B1.price.discount}} руб</span>
                                </div>
                                <div class="payments__information-item">
                                    <span class="payments__title">Цена со скидкой</span>
                                    <span class="payments__text payments__text_np">{{ordersTable.value.B1.price.final}} руб</span>
                                </div>
                                <div class="payments__information-item">
                                    <span class="payments__title">Оплачено</span>
                                    <span class="payments__text payments__text_np">{{ordersTable.value.B1.payments.reduce((sum: any, item: any) => {return sum + item.amount}, 0)}} руб</span>
                                </div>
                                <div class="payments__information-item">
                                    <span class="payments__title payments__title_gold">Остаток</span>
                                    <span class="payments__text payments__text_np">{{(ordersTable.value.B1.price.final - ordersTable.value.B1.payments.reduce((sum: any, item: any) => {return sum + item.amount}, 0)).toFixed(2)}} руб</span>
                                </div>
                            </div>
                            <ul class="payments">
                                <li class="payments__item">
                                    <span class="payments__text">№</span>
                                    <span class="payments__text">Платеж</span>
                                    <span class="payments__text payments__text_gray">Метод</span>
                                    <span class="payments__text">Дата</span>
                                </li>
                                <li class="payments__item" v-for="(item, index) in ordersTable.value.B1.payments">
                                    <span class="payments__text">{{index + 1}}</span>
                                    <span class="payments__text">{{`${item.amount} руб.`}}</span>
                                    <span class="payments__text payments__text_gray">{{item.method}}</span>
                                    <span class="payments__text">{{new Date(item.date).toLocaleDateString()}}</span>
                                </li>
                            </ul>
                            <div class="payments-box" v-if="+(ordersTable.value.B1.price.final - ordersTable.value.B1.payments.reduce((sum: any, item: any) => {return sum + item.amount}, 0)).toFixed(2) > 0">
                                <button-component buttonText="Добавить платеж" @click="activePayment = true" v-if="!activePayment && role !== UserRole.MANAGER"/>
                                <OrderPaymentsComponent :id="ordersTable.value.B1._id" @close="activePayment = false" @newPayment="setPayment" v-if="activePayment" :remains="+(ordersTable.value.B1.price.final - ordersTable.value.B1.payments.reduce((sum: any, item: any) => {return sum + item.amount}, 0)).toFixed(2)"/>
                            </div>
                        </template>
                    </popup-component>
                    <popup-component :mt="true" :isOpen="isDelete === ordersTable.value.B1._id" @close="isDelete = ''">
                        <template #title>
                            Вы хотите удалить заказ?
                        </template>
                        <template #content>
                            <div class="delete-box">
                                <button-component class="delete delete_success" buttonText="Да" @click="deleteOrder(ordersTable.value.B1._id)"/>
                                <button-component class="delete delete_close" buttonText="Нет" @click="isDelete = ''"/>
                            </div>
                        </template>
                    </popup-component>
                </template>
            </table-lite>
        </div>
    </div>
    <order-list-short-component v-if="role === 'Исполнитель'" :quantity="9999999"/>
</template>

<script setup lang="ts">
import buttonComponent from './buttonComponent.vue';
import OrderPaymentsComponent from './orderPaymentsComponent.vue';
import OrderListShortComponent from '../shared/orderListShortComponent.vue';
import PopupComponent from '../entities/popupComponent.vue'
import axios from '../app/lib/api';
import { IOrderFilter, IOrderFilterSearchBy, Order, OrderPayment, OrderStatus, OrderType, IOrderCostsAmount } from '../app/lib/types/orders';
import iconComponent from './iconComponent.vue';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { onMounted, ref, watch } from 'vue';
import toast from '../app/lib/hooks/errorToast';
import { forEach, omit } from 'lodash';
import { UserRole } from '../app/lib/types/users';
import { TOrdersTable } from '../app/lib/types/types';
import {useLoadingStore} from '../app/store/store';
import TableLite from 'vue3-table-lite/ts';
import component from 'vue3-table-lite/ts';
dayjs.extend(isBetween)

//https://github.com/linmasahiro/vue3-table-lite
//https://vue3-lite-table.vercel.app/usage/static-mode.html
const ordersTable = ref([] as any as TOrdersTable)
const sortable = {order: "A1", sort: "desc"}

const props = defineProps({
    margin: {type: Boolean},
    link: {type: Boolean},
    quantity: {type: Number, default: 0}
})

const loading = useLoadingStore()
const orders = ref([] as unknown as Order[])
const statuses = Object.values( omit(OrderStatus, 'archive'))
const role = localStorage.getItem("role")
const upOrders = ref(false)
const openPopup = ref("")
const isDelete = ref("")
const activePayment = ref(false)
const searchOptions = [
    {title: 'Номер заказа', searchBy: 'number'},
    {title: 'Год заключения', searchBy: 'createdAt'},
    {title: 'Год начала работ', searchBy: 'dates.startAt'},
    {title: 'ФИО заказчика', searchBy: 'information.client'},
    {title: 'Телефон', searchBy: 'information.clientPhone'},
    {title: 'ФИО покойного', searchBy: 'information.deceased'},
    {title: 'Год смерти', searchBy: 'information.deathDate'},
    {title: 'Кладбище', searchBy: 'information.cemetery'},
    {title: 'Статус', searchBy: 'status'},
    {title: 'Не оплачен', searchBy: 'notPaid', canBeEmpty: 'Y'},
    {title: 'Создатель заказа', searchBy: 'userId'},
    {title: 'Производимые работы', searchBy: 'services.title'},
    {title: 'Участок/ряд/место***', searchBy: ''},
    {title: 'Аванс/доплата***', searchBy: ''}
]
const userId = ref("")

watch(() => [upOrders], () => {},{ deep: true })

onMounted(() => {
    loading.loading()

    axios.users.getUserInfo()
    .then((res: any) => {
        userId.value = res.data.userId
    })

    let filter = {
        search: {
            searchBy: [{
                field: 'type',
                value: OrderType.monument
            }]
        }
    }

    axios.order.getOrderList(filter)
    .then((res: any) => {
        orders.value = res.data.result.filter((order: Order) => order.status !== OrderStatus.archive)
        prepareOrdersTable(res.data)
        loading.load()
        tableAmountHandler(filter)
    })
    .catch((err: any) => {
        loading.load()
        toast('error', "Не удалось загрузить заказы")
    })

    bindPageEvent();
})

/**
 * Обработка данных общих сумм и подстановка их в таблицу.
 */
function tableAmountHandler(filter: IOrderFilter) {
    axios.order.getOrdersAmount(filter)
    .then((res: any) => {
        const targetRow = document.querySelector('.vtl-table tbody tr:first-child')
        if(res.data.result.length > 0) {
            targetRow!.querySelector('td.L1 div span')!.innerHTML = res.data.result[0].priceFinal.toFixed(2) + ''
            targetRow!.querySelector('td.S1 div span')!.innerHTML = res.data.result[0].debtPaymentsAmount.toFixed(2) + ''
        }
        else {
            if(targetRow) {
                let tdData = targetRow!.querySelectorAll('td.priceAmount div span')
                tdData!.forEach(el => {
                    el!.innerHTML = 'Нет данных'
                }) 
            }
        }
    })
    .catch((err: any) => {
        toast('warning', err)
        console.log(err)
    })
}

/**
 * Инициализация таблицы c заказами.
 */
const initTable = (tableComponent: any) => {
    bindTableEvents(tableComponent)
}

/**
 * Добавление событий для таблицы.
 */
function bindTableEvents(tableComponent: any) {
    // Свайп таблицы правой кнопкой мыши
    let table = tableComponent.el.querySelector('.vtl-table')
    let startX = table.scrollLeft
    table.addEventListener('mousedown', (event: MouseEvent) => {
        if( event.button === 2 ) {
            event.preventDefault()
            startX = table.scrollLeft + event.pageX
            table.addEventListener('mousemove', mouseMove)
            table.addEventListener('mouseup', (event: MouseEvent) => {
                table.removeEventListener('mousemove', mouseMove)
            })
        }
    })

    // Отключение для таблицы контекстного меню для правой кнопкой мыши
    table.addEventListener('contextmenu', (event: MouseEvent) => { event.preventDefault() })

    function mouseMove(event: MouseEvent) {
        table.scrollLeft = startX - event.pageX
    }
}

/**
 * Добавление событий на страницу.
 */
function bindPageEvent() {
    selectDeselectedHandler();
}

/**
 * Получение css-класса для строки в таблицы
 */
const tableRowClassHandler = (row: any) => {
    let rowClass = ''
    switch(row.C1.status) {
        case (OrderStatus.donePayment): rowClass = 'donePayment'; break
        case (OrderStatus.refusal): rowClass = 'refusal'; break
    }
    return rowClass;
}

/**
 * Скачивание таблицы с заказами.
 */
const downloadOrders = async () => {
    loading.loading()
    let filter = {
        useTableMap: false,
        perPage: 0,
        sortBy: 'createdAt',
        sortOrder: 'desc',
        pageOffset: 0,
        search: {
            searchBy: [{
                field: 'type',
                value: OrderType.monument
            }]
        }
    }
    await axios.order.downloadOrders(filter)
    .then((r: any) => {
        const url = window.URL.createObjectURL(new Blob([r.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'отчёт.xlsx')
        document.body.appendChild(link)
        link.click()
        link.remove()
        loading.load()
    })
    .catch((err: any) => {
        toast('error', "Скачивание не удалось: " + err)
    })
}

/**
 * Получение заказов в зависимости от пагинации
 */
async function getOrders (offset: number = 0, limit: number = 10, sortby: string = 'B1', sort: string = 'desc') {
  ordersTable.value.isLoading = true
  let filter = {
    useTableMap: true,
    perPage: limit,
    sortBy: sortby,
    sortOrder: sort,
    pageOffset: offset,
    search: {
        searchBy: getSearchByParams()
    }
  }
  axios.order.getOrderList(filter)
    .then((res: any) => {
        orders.value = res.data.result.filter((order: Order) => order.status !== OrderStatus.archive)
        prepareOrdersTable(res.data, sortby, sort)
        ordersTable.value.isLoading = false;
    })
    .catch((err: any) => {
        toast('error', "Не удалось загрузить заказы: " + err)
    })
}

/**
 * Поиск заказа.
 * @param e 
 */
async function searchOrders(e: any) {
    ordersTable.value.isLoading = true
    const searchByParams = getSearchByParams()
    if(searchByParams) {
        let filter = {
            search: {
                searchBy: searchByParams
            }
        }
        ordersTable.value.isLoading = true;
        axios.order.getOrderList(filter)
        .then((res: any) => {
            orders.value = res.data.result.filter((order: Order) => order.status !== OrderStatus.archive)
            prepareOrdersTable(res.data)
            ordersTable.value.isLoading = false
            tableAmountHandler(filter)
        })
        .catch((err: any) => {
            toast('error', "Не удалось найти заказ:" + err)
        })
    }
        
    else getOrders()
}

/**
 * Обработка выбора параметров поиска.
 * @param el
 */
function selectSearchHandler(el: {title: string, searchBy: string, canBeEmpty: string}) {
    const searchInput = document.querySelector(`.order-list__search input[name="search"]`) as HTMLInputElement
    searchInput.value = ""
    searchInput.setAttribute('placeholder', el.title)
    searchInput.setAttribute('data-searchBy', el.searchBy)
    searchInput.setAttribute('data-canBeEmpty', el.canBeEmpty)
}

/**
 * Обработка сброса параметров поиска.
 */
function selectDeselectedHandler() {
    const deselect = document.querySelector('.order-list__search .vs__clear');
    if(typeof deselect != 'undefined' && deselect !== null) {
        deselect.addEventListener('click', () => {
            loading.loading()
            window.location.reload()
        })
    }
}

/**
 * Получение параметров поиска.
 */
function getSearchByParams() {
    const searchInputs:any = document.querySelectorAll(`.order-list__search__container__form-row input`);
    let searchByParams:IOrderFilterSearchBy[] = []
    
    searchInputs.forEach((searchInput: any , i: number) => {
        let searchBy = searchInput.getAttribute('data-searchBy') ? searchInput.getAttribute('data-searchBy') : ''
        if( (searchInput.value !== null && searchInput.value !== '') || searchInput.getAttribute('data-canBeEmpty') === 'Y' ) {
            switch(searchBy) {
                case 'notPaid':
                searchByParams.push({
                        field: 'status',
                        value: '',
                        useRegEx: true,
                        in: [OrderStatus.processing, OrderStatus.active, OrderStatus.done]
                    },
                    {
                        field: 'type',
                        value: OrderType.monument
                    })
                    break
                default:
                searchByParams.push({
                        field: searchBy,
                        value: searchInput.value.toString().trim(),
                        useRegEx: true
                    },
                    {
                        field: 'type',
                        value: OrderType.monument
                    })
                break
            }
        } else {
            searchByParams.push({
                field: 'type',
                value: OrderType.monument
            })
        }
    })


    // let searchByParams:IOrderFilterSearchBy[] = []
    // if(typeof(searchInput) != 'undefined' && searchInput !== null) {
    //     if( (searchInput.value !== null && searchInput.value !== '') || searchInput.getAttribute('data-canBeEmpty') === 'Y' ) {
    //         let searchBy = searchInput.getAttribute('data-searchBy') ? searchInput.getAttribute('data-searchBy') : ''
    //         switch(searchBy) {
    //             case 'notPaid':
    //                 searchByParams.push( {
    //                     field: 'status',
    //                     value: '',
    //                     useRegEx: true,
    //                     in: [OrderStatus.processing, OrderStatus.active, OrderStatus.done]
    //                 })
    //                 break
    //             default:
    //                 searchByParams.push( {
    //                     field: searchBy,
    //                     value: searchInput.value.toString().trim(),
    //                     useRegEx: true
    //                 } )
    //             break
    //         }
    //     }
    // }
    return searchByParams
}

// /**
//  * Фильтрация заказов.
//  */
// async function filterOrders(e: any) {
//     ordersTable.value.isLoading = true
//     const filterForm = new FormData(e.target)
//     const filterBy = e.submitter.getAttribute('data-filterBy')

//     let searchBy = { field: '', value: ''}
//     for(let [name, value] of filterForm) {
//         if( name === filterBy ) {
//             searchBy = {field: name, value: value.toString()}
//             break
//         }
//     }

//     if( searchBy.value !== '' ) {
//         let filter = {
//             search: {
//                 searchBy: searchBy
//             }
//         }

//         // Очистка формы
//         for(let [name, value] of filterForm) {
//             if(name !== searchBy.field) {
//                 let clearedInput: any = document.querySelector(`.order-list__filter__form-row input[name="${name}"]`)
//                 if(clearedInput !== null) clearedInput.value =''
//             }
//         }

//         ordersTable.value.isLoading = true;
//         axios.order.getOrderList(filter)
//         .then((res: any) => {
//             orders.value = res.data.result.filter((order: Order) => order.status !== OrderStatus.archive)
//             prepareOrdersTable(res.data)
//             ordersTable.value.isLoading = false
//         })
//         .catch((err: any) => {
//             toast('error', "Не удалось найти заказ: " + err)
//         })
//         // for(let [name, value] of filterForm) {
//         //     console.log(`${name} = ${value}`);
//         // } 
//     }

//     else getOrders()
// }

/**
 * Подготовка данных для вставку в основную таблицу
 * @param data 
 */
async function prepareOrdersTable(data: any, order?: string, sort?: string) {
    ordersTable.value.columns = [
        {label: "№ заказа", field: "A1", headerClasses: ["A1"], isKey: true, sortable: true},
        {label: "Статус", field: "B1", headerClasses: ["B1"], columnClasses: ["B1"]},
        {label: "", field: "C1"},
        {label: "Дата заключения", field: "D1", sortable: true},
        {label: "Дата начала работ", field: "DD", sortable: true, headerClasses: ["DD"]},
        {label: "ФИО заказчика", field: "E1"},
        {label: "Телефон", field: "F1"},
        {label: "ФИО покойного", field: "G1"},
        {label: "Дата смерти", field: "H1", sortable: true},
        {label: "Кладбище", field: "I1"},
        {label: "Участок/ряд/место", field: "J1"},
        {label: "Приемщик заказа", field: "K1", sortable: true},
        {label: "Общая сумма заказа", field: "L1", sortable: true, headerClasses: ["L1"], columnClasses: ["L1", "priceAmount"]},
        {label: "Список оказываемых услуг", field: "M1", headerClasses: ["M1", "wide"]},
        {label: "Расходники 18%", field: "N1"},
        {label: "Цена гранита", field: "O1"},
        {label: "Цена пескоструйных работ", field: "P1"},
        {label: "Цена художественных работ", field: "Q1"},
        {label: "Цена керамогранита, металлофото, эмали", field: "R1"},
        {label: "Аванс", field: "S1", headerClasses: ["S1", "semi-wide"], columnClasses: ["S1", "priceAmount"]},
        {label: "Дата внесения платежа", field: "T1", headerClasses: ["T1", "semi-wide"]},
        {label: "Камень закупка", field: "U1", headerClasses: ["U1"]},
        {label: "З/п резка + полировка", field: "V1", headerClasses: ["V1"]},
        {label: "З/п пескоструйные работы", field: "VV", headerClasses: ["VV"]},
        {label: "З/п художественные работы", field: "VVV", headerClasses: ["VVV"]},
        {label: "Себестоимость керамогранит/металлофото/эмаль", field: "W1", headerClasses: ["W1"]},
        {label: "З/п менеджер", field: "X1", headerClasses: ["X1"]},
        {label: "Имя менеджера", field: "XX", headerClasses: ["XX"]},
        {label: "З/п приемщика заказа", field: "Y1", headerClasses: ["Y1"]},
        {label: "Долг", field: "Z1", headerClasses: ["Z1"]},
        {label: "Выручка", field: "ZZ", headerClasses: ["ZZ"]},
    ]

    ordersTable.value.isLoading = false
    ordersTable.value.total = data.params.count
    ordersTable.value.sortable = { order: order, sort: sort }
    ordersTable.value.rows = []
    ordersTable.value.messages = {
        pageSizeChangeLabel: "Показывать по",
        pagingInfo: "Всего найдено: {2}",
        gotoPageLabel: "Перейти к",
        noDataAvailable: "Данных не найдено"
    },
    ordersTable.value.pageOptions = [
        {value: 10, text: "10"},
        {value: 25, text: "25"},
        {value: 50, text: "50"},
        {value: 999999999999, text: "Все"}
    ]

    // TODO Переделать на всплывающие окна
    // Добавление строки с технической информацией
    ordersTable.value.rows.push({
        A1: '', 
        B1: '', 
        C1: '',
        D1: '',
        DD: '',
        E1: '',
        F1: '',
        G1: '',
        H1: '',
        I1: '',
        J1: '',
        K1: '',
        L1: 'Загрузка...',
        M1: '',
        N1: '',
        O1: '',
        P1: '',
        Q1: '',
        R1: '',
        S1: 'Загрузка...',
        T1: '',
        U1: '',
        V1: '',
        VV: '',
        VVV: '',
        W1: '',
        X1: '',
        XX: '',
        Y1: '',
        Z1: '',
        ZZ: ''
    })
    data.result.forEach((el: any, i: number) => {
        ordersTable.value.rows.push(
            {
                A1: el.number,
                B1: el,
                C1: el,
                D1: new Date(el.createdAt).toLocaleDateString() + '',
                DD: new Date(el.dates.startAt).toLocaleDateString() + '',
                E1: el.information.client,
                F1: el.information.clientPhone,
                G1: el.information.deceased,
                H1: typeof el.information.deathDate !== 'undefined' ? new Date(el.information.deathDate).toLocaleDateString() : '---',
                I1: el.information.cemetery,
                J1: el.information.graveDistrict + '/' + el.information.graveRow + '/' + el.information.gravePlace,
                K1: el.creatorContacts.fullname,
                L1: el.price.final.toFixed(2) + '\u00a0\u20bd',
                M1: el.services.map( (service: any) => '~ ' + service.title + '\u00a0' + service.price + '\u00a0\u20bd').join('\r\n'),
                N1: (el.price.final * (18 / 100)).toFixed(2) + '\u00a0\u20bd',
                O1: getCurrentTypePrice(el, 'Гранитное изделие') + '\u00a0\u20bd',
                P1: getCurrentTypePrice(el, 'Пескоструйные работы') + '\u00a0\u20bd',
                Q1: getCurrentTypePrice(el, 'Художественные работы') + '\u00a0\u20bd',
                R1: getCurrentTypePrice(el, 'Фото') + '\u00a0\u20bd',
                S1: el.payments.map( (payment: any) => '~ ' + payment.amount + ' \u00a0\u20bd').join('\r\n'),
                T1: el.payments.map( (payment: any) => '-> ' + new Date(payment.date).toLocaleDateString()).join('\r\n'),
                U1: el.costs.stone.toFixed(2) + '\u00a0\u20bd',
                V1: el.costs.polish.toFixed(2) + '\u00a0\u20bd',
                VV: getPercentage(getCurrentTypePrice(el, 'Пескоструйные работы'), 10),
                VVV: getPercentage(getCurrentTypePrice(el, 'Художественные работы'), 20),
                W1: el.costs.net.toFixed(2) + '\u00a0\u20bd',
                X1: el.costs.manager.toFixed(2) + '\u00a0\u20bd',
                XX: el.information.manager,
                Y1: el.costs.implementer.toFixed(2) + '\u00a0\u20bd',
                Z1: el.price.final - el.payments.reduce((summ: number, payment: any) => summ + payment.amount, 0) + '\u00a0\u20bd',
                ZZ: (el.price.final - (el.price.final * (18 / 100)) - el.costs.stone - el.costs.polish - Number(getCurrentTypePrice(el, 'Пескоструйные работы')) - Number(getCurrentTypePrice(el, 'Художественные работы')) - el.costs.net - el.costs.manager - el.costs.implementer).toFixed(2) + '\u00a0\u20bd'
            }
        )
    })
}

function getCurrentTypePrice(order: any, type: string) {
    let price = 0
    order.services.forEach((service: any) => {
        if (service.type === type) {
            price += service.price
        }
    })
    return price.toFixed(2)
}

function getPercentage(summ: string, percentage: number) {
    return (Number(summ) * (percentage / 100)).toFixed(2)
}

async function setStatus(id: string, status: OrderStatus) {
    try {
        ordersTable.value.isLoading = true
        await axios.order.updateOrderStatus(id, status)
        const order = orders.value.find(order => order._id === id )
        if(order){
            order.status = status
        }
        ordersTable.value.isLoading = false
    } catch (error: any) {
        loading.load()
        toast("error", error.response.data.message)
    }
}

/**
 * Добавление данных о платеже.
 * @param data 
 */
function setPayment(data: {id: string, payment: OrderPayment}) {
    const order = orders.value.find(order => order._id === data.id)
    if(order){
        order.payments.push(data.payment)
    }
}

watch((orders.value), () => {
    forEach((orders.value), (order) => {
        if(order.payments) {
            component.forceUpdate()
        }
    })
})

/**
 * Удаление заказа.
 * @param id 
 */
async function deleteOrder(id: string) {
    try {
        loading.loading()
        await axios.order.updateOrderStatus(id, OrderStatus.archive)
        orders.value = orders.value.filter(order => order._id !== id)
        loading.load()
    } catch (error: any) {
        toast("error", error.response.data.message)
        loading.load()
    }
}
</script>